var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},_vm._l((_vm.children),function(child){return _c(_vm.blockElement(child),{tag:"div",attrs:{"text":child}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }